"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAuthenticator = void 0;
const web_ui_security_1 = require("@gruposantander/web-ui-security");
const timeOut_helper_1 = require("../../../security/timeOut/helpers/timeOut.helper");
//TODO Authenticator only for model or not??
class MbAuthenticator extends web_ui_security_1.BaseAuthenticator {
    constructor(session, xhr, getDeviceUUID) {
        super(session);
        this.doLogin = async (data) => {
            const deviceUUID = await this.getDeviceUUID();
            const os = await this.getOperatingSystem();
            const LoginInfo = {
                username: data.username,
                documentType: data.documentType,
                password: data.password,
                passwordPosition: data.passwordPosition,
                ...(data.customerSessionId ? { customerSessionId: data.customerSessionId } : {}),
                deviceInformation: {
                    deviceUUID,
                    webDeviceInfo: {
                        version: os,
                    },
                },
            };
            const response = await this.xhr.POST(`${window.MIDDLEWARE_BASE_HOST}/mb-api-auth/authentication/login`, LoginInfo, {
                headers: {
                    ...(data.progressId ? { progressId: data.progressId } : undefined),
                },
            });
            const { accessToken, refreshToken, expiresIn, sessionExpiresAt } = response.data;
            const convertedData = {
                accessToken,
                refreshToken,
                expiresIn,
                sessionExpiresAt: sessionExpiresAt ? new Date(sessionExpiresAt) : null,
                timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(expiresIn),
                customerSessionId: data.customerSessionId,
            };
            const redirectTo = (response.responseHeaders['x-security'] || response.responseHeaders['location'] || null);
            return { ...convertedData, username: data.username, redirectTo };
        };
        this.doLogout = async () => {
            const accessToken = this.getSession().getData()?.accessToken;
            await this.xhr.POST(`${window.MIDDLEWARE_BASE_HOST}/mb-api-auth/authentication/logout`, { accessToken });
        };
        this.getPasswordPositions = async (username, documentType) => {
            const PasswordPositionInfo = {
                username,
                documentType,
            };
            const response = await this.xhr.POST(`${window.MIDDLEWARE_BASE_HOST}/mb-api-auth/authentication/users/password-positions`, PasswordPositionInfo);
            return response.data;
        };
        this.getDocumentFormats = async () => {
            const response = await this.xhr.GET(`${window.MIDDLEWARE_BASE_HOST}/mb-api-localization/v1/document-formats?type=login`);
            return response.data;
        };
        this.validateDocumentFormat = async (documentType, documentValue) => {
            const DocumentTypeInfo = {
                documentType,
                documentValue,
            };
            const response = await this.xhr.POST(`${window.MIDDLEWARE_BASE_HOST}/mb-api-localization/v1/document-formats/validate`, DocumentTypeInfo);
            return response.data;
        };
        this.xhr = xhr;
        this.getDeviceUUID = getDeviceUUID;
    }
    async getOperatingSystem() {
        const WIN_11_PLATFORM_VERSION = 13;
        if (navigator.userAgentData) {
            const { platform, platformVersion } = await navigator.userAgentData.getHighEntropyValues(['platform', 'platformVersion']);
            const majorVersion = parseInt(platformVersion.split('.')[0], 10);
            if (platform === 'Windows' && majorVersion >= WIN_11_PLATFORM_VERSION) {
                return navigator.userAgent.replace('Windows NT 10.0', 'Windows NT 11.0');
            }
        }
        return navigator.userAgent;
    }
}
exports.MbAuthenticator = MbAuthenticator;
//# sourceMappingURL=index.js.map